import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import PropTypes from "prop-types";
import Loading from "components/Loading";
import {
	Modal,
	ModalBody,
	ModalFooter
} from "reactstrap";
import { ReactTable } from "components/Table";
import SelectBox from "components/elements/selectBox";
import { getStaffs } from "actions/teamActions";
import { getPromotionV2Shops, getPromotionV2ShopsProducts, saveEditAll } from "actions/promotionv2Action";
import { subStringText, isEmptyObject } from "components/Function";

function Modaleditall(props) {
	var { isLoading, listpromotionv2shops, totalsize, listpromotionv2shopsproducts, totalsize_shopsproducts } = props.promotionv2;
	var { isOpenModalEditAll, openModal, getStaffs, getPromotionV2Shops, getPromotionV2ShopsProducts, subStringText, saveEditAll, editall, isEmptyObject, modal_type } = props;
	const [type, setType] = useState(editall?.type || "");
	const [value, setValue] = useState(editall?.value || "");
	const [time, setTime] = useState(editall?.time || "");
	const [page, setPage] = useState(1);
	const [sizePerPage, setSizePerPage] = useState(50);
	const [searchText, setSearchText] = useState("");
	const [totalSize, setTotalSize] = useState(0);
	const [staffs, setStaffs] = useState([]);
	const [filter, setFilter] = useState({});
	const [shops_selected, setShopsSelected] = useState(editall?.shops_selected || []);
	const [page2, setPage2] = useState(1);
	const [sizePerPage2, setSizePerPage2] = useState(10);
	const [searchText2, setSearchText2] = useState("");
	const [totalSize2, setTotalSize2] = useState(0);
	const [products_selected, setProductsSelected] = useState(editall?.products_selected || []);
	const [check_all_products, setCheckAllProducts] = useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		getStaffs({ sizeperpage: 100 }).then((data) => {
			setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email })) || []);
		});
	}, [getStaffs]);

	useEffect(() => {
		getPromotionV2Shops({ page, sizeperpage: sizePerPage, search: searchText, filter });
	}, [getPromotionV2Shops, page, sizePerPage, searchText, filter]);

	// useEffect(() => {
	// 	if (!isEmptyObject(editall)) {
	// 		setType(editall?.type);
	// 		setValue(editall?.value);
	// 		setShopsSelected(editall?.shops_selected);
	// 		setProductsSelected(editall?.products_selected);
	// 	}
	// }, [isEmptyObject]);

	useEffect(() => {
		if (isEmptyObject(editall) && type === "" && shops_selected.length > 0) {
			return;
		}
		getPromotionV2ShopsProducts({ page: page2, sizeperpage: sizePerPage2, search: searchText2, filter: { shops_selected: shops_selected.join(), type, modal_type } });
	}, [getPromotionV2ShopsProducts, page2, sizePerPage2, searchText2, shops_selected, type]);

	useEffect(() => {
		setTotalSize(totalsize);
	}, [totalsize]);

	useEffect(() => {
		setTotalSize2(totalsize_shopsproducts);
	}, [totalsize_shopsproducts]);

	const onClickSaveEditAll = () => {
		saveEditAll({ type, value, time, shops_selected, products_selected, check_all_products, modal_type }, openModal);
	};

	const onChange = (e) => {
		if (e.target.name === "type") {
			setType(e.target.value);
		}
		if (e.target.name === "value") {
			setValue(e.target.value);
		}
		if (e.target.name === "time") {
			setTime(e.target.value);
		}
	}

	const onOpenModal = () => {
		setType("");
		setValue("");
		setShopsSelected([]);
		setProductsSelected([]);
		getPromotionV2Shops({ page: 1, sizeperpage: 50, search: "", filter: {} });
		openModal();
	};

	const onKeyPress = (e) => {
		if ((/^[0-9.]+$/).test(e)) {
			e.preventDefault();
		}
	}

	const onClickSelectAllProducts = async () => {
		setProductsSelected([]);
		setCheckAllProducts(!check_all_products);
	};

	const columns = [{
		dataField: '_id',
		text: "",
		sort: true,
		style: {
			width: "50px",
		},
		formatter: (cell, row, rowIndex) => rowIndex + 1
	}, {
		dataField: 'name',
		text: t("Shop Name"),
		sort: true,
	}, {
		dataField: 'staff',
		text: t("Staff"),
		sort: true,
		formatter: (cell, row, rowIndex) => cell ? cell.map((v, i) => v?.email).join() : ""
	}];

	const groupButton = () => {
		return (
			<div className="mb-5 d-flex gap-2 flex-wrap">
				<SelectBox
					options={staffs}
					name="filter_staff"
					value={filter.staff || ""}
					onChange={(data) =>
						setFilter((prev) => ({
							...prev,
							staff: data.value || "",
						}))
					}
					className="cotik-select-virtual me-2 mb-2"
				/>
			</div>
		);
	}

	const handleTableChange = (type, { page, sizePerPage, searchText }) => {
		if (type === "search") {
			setPage(1);
			setSizePerPage(50);
			setSearchText(searchText);
		} else {
			setPage(page || 1);
			setSizePerPage(sizePerPage);
		}
	}

	const removeSelect = (arr, value) => {
		var i = 0;
		while (i < arr.length) {
			if (arr[i] === value) {
				arr.splice(i, 1);
			} else {
				++i;
			}
		}
		return arr;
	}

	const onSelect = (row, isSelect) => {
		var shops_selected_tmp = shops_selected;
		if (isSelect) {
			shops_selected_tmp.push(row._id);
		} else {
			shops_selected_tmp = removeSelect(shops_selected_tmp, row._id);
		}
		var new_arr = JSON.stringify(shops_selected_tmp);
		setShopsSelected(JSON.parse(new_arr));
	};

	const onSelectAll = (isSelect, row) => {
		var shops_selected_tmp = shops_selected;
		if (isSelect) {
			shops_selected_tmp = row.map((v, i) => v._id);
		} else {
			shops_selected_tmp = [];
		}
		setShopsSelected(shops_selected_tmp);
	};

	const selectRow = {
		mode: 'checkbox',
		clickToSelect: false,
		selected: shops_selected,
		onSelect: onSelect,
		onSelectAll: onSelectAll,
		selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
			<div className="d-flex">
				<input
					type="checkbox"
					ref={(input) => {
						if (input) {
							input.indeterminate = indeterminate;
							input.checked = checked;
						}
					}}
					onChange={onChange}
				/>
				<span style={{ marginLeft: '8px' }}>({shops_selected.length})</span>
			</div>
		),
	};

	const sizePerPageList = [
		{
			text: '10', value: 10
		},
		{
			text: '50', value: 50
		},
		{
			text: '100', value: 100
		},
		{
			text: '150', value: 150
		},
		{
			text: '200', value: 200
		},
		{
			text: 'All', value: totalsize || 50
		}
	];

	const columns2 = [{
		dataField: '_id',
		text: "",
		sort: true,
		style: {
			width: "50px",
		},
		formatter: (cell, row, rowIndex) => rowIndex + 1
	}, {
		dataField: 'shopId',
		text: t("Shop Name"),
		sort: true,
		formatter: (cell, row) => listpromotionv2shops.find((v) => v._id === cell)?.name || "",
	}, {
		dataField: "title",
		text: t("Title"),
		sort: true,
		formatter: (cell, row) => (
			<Fragment>
				<div className="symbol symbol-50px me-2">
					<img src={row?.main_images?.[0] || require("components/assets/media/misc/image.png")} alt="" />
				</div>
				<div className="d-inline-block">
					<span className="text-gray-900 fw-bold text-hover-primary mb-1 fs-6">{subStringText(cell, 130)}</span>
				</div>
			</Fragment>
		),
	}, {
		dataField: 'totalOrder',
		text: t("Total Order"),
		sort: true,
	}, {
		dataField: "price",
		text: t("Price"),
		sort: true,
	}];

	const groupButton2 = () => {
		return (
			<div className="mb-5 d-flex gap-2 flex-wrap">
				<button onClick={() => { onClickSelectAllProducts() }} type="button" className={cx("btn btn-sm me-2 mb-2", { "btn-secondary": !check_all_products, "btn-success": check_all_products })}>
					<i className={cx("ki-outline fs-2", { "ki-cross-square": !check_all_products, "ki-check-square": check_all_products })}></i> {t("Select all products")}
				</button>
			</div>
		);
	}

	const handleTableChange2 = (type, { page, sizePerPage, searchText }) => {
		if (type === "search") {
			setPage2(1);
			setSizePerPage2(10);
			setSearchText2(searchText);
		} else {
			setPage2(page || 1);
			setSizePerPage2(sizePerPage);
		}
	}

	const removeSelect2 = (arr, value) => {
		var i = 0;
		while (i < arr.length) {
			if (arr[i]._id === value) {
				arr.splice(i, 1);
			} else {
				++i;
			}
		}
		return arr;
	}

	const onSelect2 = (row, isSelect) => {
		var products_selected_tmp = products_selected;
		if (isSelect) {
			products_selected_tmp.push(row);
		} else {
			products_selected_tmp = removeSelect2(products_selected_tmp, row._id);
		}
		var new_arr = JSON.stringify(products_selected_tmp);
		setProductsSelected(JSON.parse(new_arr));
	};

	const onSelectAll2 = (isSelect, row) => {
		var products_selected_tmp = products_selected;
		if (isSelect) {
			products_selected_tmp = row.map((v, i) => v);
		} else {
			products_selected_tmp = [];
		}
		setProductsSelected(products_selected_tmp);
	};

	const selectRow2 = {
		mode: 'checkbox',
		clickToSelect: false,
		selected: products_selected.map((v, i) => v._id),
		onSelect: onSelect2,
		onSelectAll: onSelectAll2,
		selectionHeaderRenderer: ({ indeterminate, checked, onChange }) => (
			<div className="d-flex">
				<input
					type="checkbox"
					ref={(input) => {
						if (input) {
							input.indeterminate = indeterminate;
							input.checked = checked;
						}
					}}
					onChange={onChange}
				/>
				<span style={{ marginLeft: '8px' }}>({products_selected.length})</span>
			</div>
		),
	};

	const sizePerPageList2 = [
		{
			text: '10', value: 10
		},
		{
			text: '50', value: 50
		},
		{
			text: '100', value: 100
		},
		{
			text: '150', value: 150
		},
		{
			text: '200', value: 200
		},
		{
			text: 'All', value: totalsize || 50
		}
	];

	return (
		<Fragment>
			<Modal centered={true} fullscreen={true} toggle={() => { onOpenModal() }} isOpen={isOpenModalEditAll}>
				<Loading isLoading={isLoading} />
				<div className="modal-header">
					<h1 className="mb-0 text-dark">{t("Setup V2")}</h1>
					<div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
						<i className="ki-outline ki-cross fs-1" onClick={() => { onOpenModal() }} ></i>
					</div>
				</div>
				<ModalBody>
					<div className="row">
						<div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
							<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
								<span>{t("Type")}</span>
							</label>
							<select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a type" value={type} name="type" onChange={(e) => { onChange(e) }} disabled={!isEmptyObject(editall)} >
								<option value="">{t("-- Select a type --")}</option>
								<option value="type_1">{t("Type 1")}</option>
								<option value="type_2">{t("Type 2")}</option>
								<option value="type_3">{t("Type 3")}</option>
							</select>
						</div>
						<div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
							<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
								<span>{t("Value")}</span>
							</label>
							<input type="text" className="form-control" value={value} placeholder="" name="value" onChange={(e) => { onChange(e) }} onKeyPress={(e) => { onKeyPress(e) }} />
						</div>
						<div className="col-12 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
							<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
								<span>{t("Time")}</span>
							</label>
							<select className="form-select" data-control="select2" data-hide-search="true" data-placeholder="Select a time" value={time} name="time" onChange={(e) => { onChange(e) }} >
								<option value="">{t("-- Select a time --")}</option>
								<option value="1">{t("1 day")}</option>
								<option value="2">{t("2 days")}</option>
								<option value="3">{t("3 days")}</option>
							</select>
						</div>
					</div>
					<hr />
					<div className="row">
						<div className={cx("d-flex flex-column mb-4 fv-row fv-plugins-icon-container", { "col-6": isEmptyObject(editall), "d-none": !isEmptyObject(editall) })} style={{ borderRight: "1px solid #cecece" }}>
							<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
								<span>{t("Shop")}</span>
							</label>
							<div className="al-variants-table">
								<ReactTable columns={columns} data={listpromotionv2shops} groupButton={groupButton} handleTableChange={handleTableChange} page={page} sizePerPage={sizePerPage} totalSize={totalSize} alClassName="table-layout-inherit" isSelectRow={true} selectRow={selectRow} sizePerPageList={sizePerPageList} />
							</div>
						</div>
						<div className={cx("d-flex flex-column mb-4 fv-row fv-plugins-icon-container", { "col-6": isEmptyObject(editall), "col-12": !isEmptyObject(editall) })} style={{ borderLeft: "1px solid #cecece" }}>
							<label className="d-flex align-items-center fs-6 fw-semibold mb-2">
								<span>{t("Product")}</span>
							</label>
							<div className="al-variants-table">
								<ReactTable columns={columns2} data={listpromotionv2shopsproducts} groupButton={groupButton2} handleTableChange={handleTableChange2} page={page2} sizePerPage={sizePerPage2} totalSize={totalSize2} alClassName={cx("table-layout-inherit", { "al-disabled": check_all_products })} isSelectRow={true} selectRow={selectRow2} sizePerPageList={sizePerPageList2} />
							</div>
						</div>
					</div>
				</ModalBody>
				<ModalFooter>
					<button type="reset" id="kt_modal_users_search_reset" data-bs-dismiss="modal" className="btn btn-active-light me-3" onClick={() => { onOpenModal() }} >{t("Cancel")}</button>
					<button type="submit" id="kt_modal_users_search_submit" className={cx("btn", { "btn-primary": modal_type === "plus", "btn-danger": modal_type !== "plus" })} onClick={() => { onClickSaveEditAll() }}  >{modal_type === "plus" ? t("Save") : t("Delete")}</button>
				</ModalFooter>
			</Modal>
		</Fragment>
	);
}

Modaleditall.propTypes = {
	getStaffs: PropTypes.func.isRequired,
	getPromotionV2Shops: PropTypes.func.isRequired,
	getPromotionV2ShopsProducts: PropTypes.func.isRequired,
	subStringText: PropTypes.func.isRequired,
	saveEditAll: PropTypes.func.isRequired,
	isEmptyObject: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
	promotionv2: state.promotionv2
});
const mapDispatchToProps = {
	getStaffs,
	getPromotionV2Shops,
	getPromotionV2ShopsProducts,
	subStringText,
	saveEditAll,
	isEmptyObject,
}

export default connect(mapStateToProps, mapDispatchToProps)(Modaleditall);